module.exports = __webpack_public_path__ + "static/media/undertaleneutral.a8807f5a.png";